export default {"src":"/_next/static/media/footerlogo.e272c0f1.svg","height":150,"width":725,"blurWidth":0,"blurHeight":0};